import React, { useMemo, useRef } from 'react';
import { useSelector, shallowEqual } from 'react-redux';
import { RootReducer } from 'redux/reducers';
import * as S from './styles';
import { selectFrames } from 'redux/db/reducers';
import ScrollingSection from 'components/Panel/ScrollingSection';
import FrameListItem from '../FrameListItem';

// shows the user a hierarchical view of the frames that are currently loaded in the scene
const FrameList = () => {
	const ref = useRef() as React.MutableRefObject<HTMLDivElement>;

	const { frames } = useSelector((r: RootReducer) => {
		return {
			frames: selectFrames(r.db),
		};
	}, shallowEqual);

	//------------------------------------------------------------------------------------------------
	// HOOKS
	//------------------------------------------------------------------------------------------------
	const sortedItems = useMemo(() => {
		const items = [...frames];
		return items
			.sort((a, b) => new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime())
			.map((item) => <FrameListItem frame={item} key={item.id} />);
	}, [frames]);

	//------------------------------------------------------------------------------------------------
	// RENDERING
	//------------------------------------------------------------------------------------------------
	return (
		<S.Base ref={ref}>
			<ScrollingSection>
				<S.Items>{sortedItems}</S.Items>
			</ScrollingSection>
		</S.Base>
	);
};

export default FrameList;
